import { ThemeEnum } from '../enum/Theme';

export type Theme = ThemeEnum.LIGHT | ThemeEnum.DARK;

const THEME_KEY = 'user_theme';

export function applyTheme(theme: ThemeEnum) {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(THEME_KEY, theme);
}

export function loadStoredTheme(): ThemeEnum {
  const stored = localStorage.getItem(THEME_KEY) as ThemeEnum | null;
  return stored === ThemeEnum.DARK ? ThemeEnum.DARK : ThemeEnum.LIGHT;
}
